var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terminal"},[_c('div',{staticClass:"terminal__main"},[_c('center',[_c('h1',{staticClass:"header1"},[_vm._v(" Waiting for connection")])]),_c('adx-loading-secondary',{attrs:{"slot":"loading"},slot:"loading"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }